import { useEffect, useState } from "react";
import TopSection from "../../LT/TopSection";
import Cards from "../../../components/common/card/Card";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import './Reporting.css';
import { getPowerBIActionDashboardData } from "../../../redux/actions/PowerBIActionDashboardSlice";
import { Loader } from "../../../components/common/Loader";

const Reporting = () => {
    const dispatch = useDispatch();

    const [activeItem, setActiveItem] = useState(
        localStorage.getItem("reportsActiveItem") || "Forecast Change Audit Log"
    );

    const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
    const stateSelector = useSelector((state) => state.PowerBIActionDashboardSlice);
    const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
    const [powerBIReportID, setPowerBIReportID] = useState("");

    const reportsConfig = {
        // "Adoption % of Auto PO - Split by Ariba vs Non-Ariba": {
        //     groupId: process.env.REACT_APP_PBI_PO_ADOPTION_SPLIT_BY_ARIBA_GROUP_ID,
        //     reportId: process.env.REACT_APP_PBI_PO_ADOPTION_SPLIT_BY_ARIBA_REPORT_ID,
        // },
        // "Adoption % of Auto PO - By Plant and Purchasing Groups": {
        //     groupId: process.env.REACT_APP_PBI_PO_ADOPTION_BY_PLANT_PG_GROUP_ID,
        //     reportId: process.env.REACT_APP_PBI_PO_ADOPTION_BY_PLANT_PG_REPORT_ID,
        // },
        // "Details of POs with Rescheduling & Email Correspondence": {
        //     groupId: process.env.REACT_APP_PBI_PO_RESCHEDULING_EMAIL_GROUP_ID,
        //     reportId: process.env.REACT_APP_PBI_PO_RESCHEDULING_EMAIL_REPORT_ID,
        // },
        // "Auto PO Adoption Over Months": {
        //     groupId: process.env.REACT_APP_PBI_PO_ADOPTION_OVER_MONTHS_GROUP_ID,
        //     reportId: process.env.REACT_APP_PBI_PO_ADOPTION_OVER_MONTHS_REPORT_ID,
        // },
        // "Auto PO Time/Effort Savings": {
        //     groupId: process.env.REACT_APP_PBI_PO_TIME_EFFORT_SAVINGS_GROUP_ID,
        //     reportId: process.env.REACT_APP_PBI_PO_TIME_EFFORT_SAVINGS_REPORT_ID,
        // },
        "Forecast Change Audit Log": {
            groupId: process.env.REACT_APP_FORECAST_CHANGE_AUDIT_LOG_GROUP_ID,
            reportId: process.env.REACT_APP_FORECAST_CHANGE_AUDIT_LOG_REPORT_ID,
        },
        "Training Content Adoption": {
            groupId: process.env.REACT_APP_TOTAL_CONTENT_ADOPTION_GROUP_ID,
            reportId: process.env.REACT_APP_TOTAL_CONTENT_ADOPTION_REPORT_ID,
        },
        "Supplier Forecast Confirmation": {
            groupId: process.env.REACT_APP_SUPPLIER_FORECAST_CONFIRMATION_GROUP_ID,
            reportId: process.env.REACT_APP_SUPPLIER_FORECAST_CONFIRMATION_REPORT_ID,
        },
        "Supplier Forecast Accuracy (Plant material level)": {
            groupId: process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_PLANT_GROUP_ID,
            reportId: process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_PLANT_REPORT_ID,
        },
        "Supplier Forecast Accuracy (Plant supplier material level)": {
            groupId: process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_GROUP_ID,
            reportId: process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_REPORT_ID,
        },
        "Missing Forecasted Materials": {
            groupId: process.env.REACT_APP_MISSING_MATERIALS_GROUP_ID,
            reportId: process.env.REACT_APP_MISSING_MATERIALS_REPORT_ID,
        },


    };

    const cardData = [
        // { title: "Adoption % of Auto PO - Split by Ariba vs Non-Ariba" },
        // { title: "Adoption % of Auto PO - By Plant and Purchasing Groups" },
        // { title: "Details of POs with Rescheduling & Email Correspondence" },
        // { title: "Auto PO Adoption Over Months" },
        // { title: "Auto PO Time/Effort Savings" },
        { title: "Forecast Change Audit Log" },
        { title: "Training Content Adoption" },
        { title: "Supplier Forecast Confirmation" },
        {
            title: "Supplier Forecast Accuracy (Plant material level)",
            displayTitle: (
                <>
                    Supplier Forecast Accuracy
                    <br />
                    (Plant material level)
                </>
            )
        },
        {
            title: "Supplier Forecast Accuracy (Plant supplier material level)",
            displayTitle: (
                <>
                    Supplier Forecast Accuracy
                    <br />
                    (Plant supplier material level)
                </>
            )
        },
        {
            title: "Missing Forecasted Materials",
            displayTitle: (
                <>
                    Missing Forecasted Materials
                </>
            )
        },
    ];

    const callBackFunction = (index, title) => {
        setActiveItem(title);
        localStorage.setItem("reportsActiveItem", title);
    };

    useEffect(() => {
        const getPowerBIReportDetails = async () => {
            try {
                const selectedReport = reportsConfig[activeItem];
                console.log("activeItem:", activeItem);
                console.log("selectedReport", selectedReport)
                console.log(
                    "PLANT GROUP:",
                    process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_PLANT_GROUP_ID
                );

                console.log(
                    "PLANT REPORT:",
                    process.env.REACT_APP_SUPPLIER_FORECAST_ACCURACY_PLANT_REPORT_ID
                );
                const response = await dispatch(
                    getPowerBIActionDashboardData({
                        dynamicEndpoint: `api/powerBI/embedDetails/group/${selectedReport.groupId}/report/${selectedReport.reportId}`,
                    })
                );

                if (response?.meta?.requestStatus === "fulfilled") {
                    setPowerBIEmbedURL(response?.payload?.embedUrl);
                    setPowerBIReportID(response?.payload?.reportId);
                    setPowerBIAccessToken(response?.payload?.accessToken);
                } else {
                    toast.error(response?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error("API error:", error);

                toast.error("Failed to load report", {
                    autoClose: 2000,
                });
            }
        };

        getPowerBIReportDetails();
    }, [activeItem]);

    const embedConfig = {
        type: "report",
        id: powerBIReportID,
        embedUrl: powerBIEmbedURL,
        accessToken: powerBIAccessToken,
        tokenType: models.TokenType.Embed,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
            },
            navContentPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
            },
        },
    };

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Reports" },
                ]}
                tabTitle="Reports"
            />

            <div className="container">
                <Cards
                    cards={cardData}
                    showBorder={true}
                    callBackFunction={callBackFunction}
                />
            </div>
            {stateSelector?.loading ? <Loader /> :
                <div className="powerBi_cls" style={{ marginTop: 10 }}>
                    {embedConfig?.embedUrl &&
                        embedConfig?.accessToken && (
                            <PowerBIEmbed embedConfig={embedConfig} />
                        )}
                </div>}
        </div>
    );
};
 
export default Reporting;